import React, { useEffect, useState } from 'react';
import { Button } from '@/components';
import { Input } from '@/components';
import { useBts } from '@/context/btsContext/BtsContextProvider';
import { useModal } from '@/components/common/modal/ModalContext';

const Step2Report = ({ proposalId, data, schoolName }) => {
  const [categoryCode, setCategoryCode] = useState([]); //category code
  const [errors, setErrors] = useState({});
  const { saveCategoryCodeAPI } = useBts();
  const { closeModal } = useModal();

  useEffect(() => {
    if (data && data.length > 0) {
      const transformed = data.map((item) => ({
        classId: item.id,
        categoryCode: '',
      }));
      setCategoryCode(transformed);
    }
  }, [data]);

  // const res-body = [ { classId : '1' , catCode : 'ABC-123'}]

  const handleCategoryChange = (classId, value) => {
    setCategoryCode((prev) =>
      prev.map((cls) =>
        cls.classId === classId ? { ...cls, categoryCode: value } : cls,
      ),
    );
  };

  useEffect(() => {
    console.log(categoryCode);
  }, [categoryCode]);

  const handleSave = async () => {
    let newErrors = {};
    let isValid = true;

    categoryCode.forEach((cls) => {
      if (!cls.categoryCode || cls.categoryCode.trim() === '') {
        newErrors[cls.classId] = 'Category code is required';
        isValid = false;
      }
    });

    setErrors(newErrors);
    if (!isValid) return;

    try {
      await saveCategoryCodeAPI(proposalId, categoryCode, schoolName);
      console.log('Category codes saved successfully!');
      closeModal();
    } catch (error) {
      console.error('Failed to save category codes:', error);
    }
  };

  return (
    <div className="p-4 bg-white rounded shadow-lg w-full max-w-2xl mx-auto">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold">Step 2 Report</h2>
      </div>
      <table className="w-full ">
        <thead>
          <tr>
            <th className=" px-2 py-1">Class</th>
            <th className=" px-2 py-1">Category Code</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data.map((cls) => (
              <tr key={cls.id}>
                <td className=" px-2 py-1">{cls.className}</td>
                <td className=" px-2 py-1">
                  <Input
                    type="text"
                    value={
                      categoryCode.find((c) => c.classId === cls.id)
                        ?.categoryCode || ''
                    }
                    onChange={(e) =>
                      handleCategoryChange(cls.id, e.target.value)
                    }
                    className="px-2 py-1 w-full"
                    error={errors[cls.id]}
                    required
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      <td className="flex justify-end mt-4">
        <Button
          onClick={handleSave}
          className="bg-blue-500 text-white px-4 py-2 rounded">
          Save and Export step-2 report
        </Button>
      </td>
    </div>
  );
};

export default Step2Report;
